import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { User, ChevronDown, LogOut } from 'lucide-react';
import './Header.css';

const Header = () => {
  const { user, logout, isLoading } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const menuRef = useRef(null);

  const handleLogout = async () => {
    if (window.confirm('确定要退出登录吗？')) {
      await logout();
    }
    setShowUserMenu(false);
  };

  const toggleUserMenu = () => {
    setShowUserMenu(!showUserMenu);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    };

    if (showUserMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showUserMenu]);

  return (
    <header className="global-header">
      <div className="logo-section">
        <img src="/logo.png" alt="深锶科技" className="logo-img" />
        <span className="logo-text">深锶数字人</span>
      </div>

      <div className="header-right">
        <a href="https://s.apifox.cn/5eecde19-51b7-4c3a-abf2-69f3b12db467?pwd=NjKlZeid" className="api-link" target="_blank">
          API文档
        </a>

        <div className="user-section" ref={menuRef}>
          <div className="user-info" onClick={toggleUserMenu}>
            <div className="user-avatar">
              <User size={14} />
            </div>
            <span className="user-phone">{user?.phone || '用户'}</span>
            <ChevronDown size={14} className="dropdown-arrow" />
          </div>

          {showUserMenu && (
            <div className="user-menu">
              <div className="user-menu-item" onClick={handleLogout}>
                <LogOut size={14} />
                <span>{isLoading ? '退出中...' : '退出登录'}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
